<template>
  <div>未注册在views下</div>
</template>

<script>
export default {

}
</script>
